import api from "@/utils/api.util";

export class FirmService {
  static RESOURCE = "/firms/";

  static all(params = {}) {
    return api.get(this.RESOURCE, { params });
  }

  static create(data = {}) {
    return api.post(this.RESOURCE, data);
  }

  static update(id, data = {}) {
    return api.put(this.RESOURCE + id, data);
  }

  static assessmentPeriod(id, params = {}) {
    return api.get(this.RESOURCE + id + "/assessment-period", { params });
  }

  static getContracts(id, params = {}) {
    return api.get(this.RESOURCE + id + "/contracts", { params });
  }
}
